<script>
  import { onMount } from 'svelte';
  import { image } from "../toolbox.js";

  export let block;

</script>

<section>
  <div class="container-fluid px-0">
    <img class="paralax-image d-none d-lg-block" style="width: 100%" src="{image(block, 'picture', [2000, 700])}" alt="" />
    <img class="paralax-image d-block d-lg-none" style="width: 100%" src="{image(block, 'picture', [800, 800])}" alt="" />
  </div>
</section>
